import React from 'react';
import { HttpErrorProps } from '../../../../hooks/useHttpError';
import { GenericError } from '../../generic/genericError';

export interface LayoutErrorProps extends HttpErrorProps {
  email?: string;
  onLogout?: () => void;
}

export const LayoutError: React.FC<LayoutErrorProps> = props => {
  return <GenericError {...props} />;
};
